import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import DeviceData from 'drivers/deviceData';
import getIsRTLLanguage from './isRTL';
import { getCurrentMultiListPosition, getNavigationConfig } from './navigationHelpers';

let focusData = { focusIndex: 0, enter: false };

const onMainMenuKeyPress = async (event = null) => {
  const tvKeyControls = await DeviceData.getTVControl();
  const isRTL = getIsRTLLanguage();

  return handleMultiListNavigation(event, tvKeyControls, isRTL);
};

const handleMultiListNavigation = async (event, tvKeyControls, isRTL) => {
  const { lists, betweenListsKey = 'vertical' } = getNavigationConfig();

  // Get current position from storage
  const currentPosition = getCurrentMultiListPosition();
  let { listIndex, itemIndex } = currentPosition;
  let enter = false;

  // Define key mappings based on RTL
  const keyMapping = {
    [tvKeyControls.KEY_LEFT]: isRTL ? tvKeyControls.KEY_RIGHT : tvKeyControls.KEY_LEFT,
    [tvKeyControls.KEY_RIGHT]: isRTL ? tvKeyControls.KEY_LEFT : tvKeyControls.KEY_RIGHT,
    [tvKeyControls.KEY_UP]: tvKeyControls.KEY_UP,
    [tvKeyControls.KEY_DOWN]: tvKeyControls.KEY_DOWN,
  };

  // Determine which keys do what based on betweenListsKey setting
  const mappedKey = keyMapping[event.keyCode] || event.keyCode;

  let betweenListsKeys, withinListKeys;

  // Only set up key mappings for multi-list scenarios
  if (lists.length > 1) {
    if (betweenListsKey === 'vertical') {
      betweenListsKeys = [tvKeyControls.KEY_UP, tvKeyControls.KEY_DOWN];
      withinListKeys = [tvKeyControls.KEY_LEFT, tvKeyControls.KEY_RIGHT];
    } else {
      betweenListsKeys = [tvKeyControls.KEY_LEFT, tvKeyControls.KEY_RIGHT];
      withinListKeys = [tvKeyControls.KEY_UP, tvKeyControls.KEY_DOWN];
    }
  }

  const currentListLength = lists[listIndex] || 1;

  if (lists.length === 1) {
    // Single list - all directional keys navigate within the list
    switch (mappedKey) {
      case tvKeyControls.KEY_RIGHT:
      case tvKeyControls.KEY_DOWN:
        itemIndex = (itemIndex + 1) % currentListLength;
        break;
      case tvKeyControls.KEY_LEFT:
      case tvKeyControls.KEY_UP:
        itemIndex = (itemIndex - 1 + currentListLength) % currentListLength;
        break;
      case tvKeyControls.KEY_ENTER:
        enter = true;
        break;
      default:
        return null;
    }
  } else {
    // Multi-list navigation
    switch (mappedKey) {
      case withinListKeys[1]: // Next item in current list
        itemIndex = (itemIndex + 1) % currentListLength;
        break;
      case withinListKeys[0]: // Previous item in current list
        itemIndex = (itemIndex - 1 + currentListLength) % currentListLength;
        break;
      case betweenListsKeys[1]: // Next list
        listIndex = (listIndex + 1) % lists.length;
        itemIndex = 0; // Focus first item of new list
        break;
      case betweenListsKeys[0]: // Previous list
        listIndex = (listIndex - 1 + lists.length) % lists.length;
        itemIndex = 0; // Focus first item of new list
        break;
      case tvKeyControls.KEY_ENTER:
        enter = true;
        break;
      default:
        return null;
    }
  }

  return sendToMultiListGrid(listIndex, itemIndex, enter);
};

const sendToMultiListGrid = (listIndex, itemIndex, enter) => {
  // For single list (backward compatibility), store just the number
  if (listIndex === 0) {
    Storages.MainStorage.setItem(StorageKeys.Keys.FOCUSINDEX, itemIndex);
    // Also update legacy focusData for any remaining dependencies
    focusData.focusIndex = itemIndex;
    focusData.enter = enter;
  } else {
    // Store in format "listIndex,itemIndex" for multi-list
    const focusValue = `${listIndex},${itemIndex}`;
    Storages.MainStorage.setItem(StorageKeys.Keys.FOCUSINDEX, focusValue);
  }

  return {
    listIndex,
    itemIndex,
    enter,
  };
};

export default onMainMenuKeyPress;
